import {useContext} from 'react';
import {LoopContext} from 'components/forms/context';

/**
 * Hoist a react-hook-form
 */
export default function useFormLoopPrefix() {
    const loop = useContext(LoopContext);

    const wrapFieldWithLoop = name => {
        if (Array.isArray(name)) {
            return name.map(item => wrapFieldWithLoop(item));
        } else if (name) {
            if (loop?.parent) {
                return `${loop.parent.node}[${loop.parent.index}].${loop.node}[${loop.index}].${name}`
            }
            return loop ? `${loop.node}[${loop.index}].${name}` : name;
        }
        return null;
    }

    return wrapFieldWithLoop;
}
